import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EncryptionService } from '../encryption/encryption.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestInterceptorService implements HttpInterceptor {

  constructor(private readonly encryptionService: EncryptionService) { }
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url?.includes(environment.cva_url) && request.body) {
          this.encryptionService.encryptAllTextFields(request.body)
      }
    const reqClone = request.clone();
    return next.handle(reqClone);
  }
}
